/* eslint-disable max-lines */
/* eslint-disable max-len */
/* eslint-disable consistent-return */
/* eslint-disable complexity */

import VTable from '@/components/table';
import { localStorageUser } from '../use/localstorage.space';
import ExportsFormatter from '../use/ExportsFormatter';

export default {
  /**
   * @override
   */
  data() {
    return {
      items: null,
      columns: null,
      orderby: '',
      metadata: null,
      isLoading: false,
      componentKey: 0,
      section: '',
      filters: null,
      tbFilters: [],
      views: null,
      search: null
    };
  },

  components: {
    VTable
  },

  methods: {
    allowExternalCodesFromSystemMappings() {
      return this.$store.getters['configVarsStore/getAllowExternalCodesFromSM'];
    },
    /**
     * CARGAMOS LOS DATOS DE UNA TABLA
     * Consultamos los datos iniciales de una tabla
     * @param {Object} payload Sección que se quiere paginar, ordenación y cfg
     * @return {Object} Resultados de la tabla
     */
    loadData(payload) {
      this.componentKey++;
      const hasSearch = this.search && this.search.length && JSON.parse(this.search)[0] !== '';
      if (typeof payload.sort === 'object' || payload.sort === undefined) {
        payload.sort = this.getDefaultOrderBy();
      }
      switch (payload.section) {
        case 'issues':
          return hasSearch
            ? this.$issuesService.getSearch(this.search, payload.cfg, payload.sort)
            : this.$issuesService.getIssues(payload.sort, payload.cfg);
        case 'users':
          return hasSearch
            ? this.$usersService.getSearch(this.search, payload.cfg, payload.sort)
            : this.$usersService.getUsers(payload.sort, payload.cfg);
        case 'groups':
          return hasSearch
            ? this.$groupsService.getSearch(this.search, payload.cfg, payload.sort)
            : this.$groupsService.getGroups(payload.sort, payload.cfg);
        case 'permission_set':
          return hasSearch
            ? this.$permissionService.getSearch(this.search, payload.cfg, payload.sort)
            : this.$permissionService.getPermissions(payload.sort, payload.cfg);
        case 'interveners':
          payload.cfg.params = payload.cfg.params || {};
          payload.cfg.params['$expand'] = 'distributor,subdistributor,videoidentification_status';
          if (this.$route.query['modifications-monitor']) {
            payload.cfg.params['modifications-monitor'] = this.$route.query['modifications-monitor'];
          }
          return hasSearch
            ? this.$intervenersService.getSearch(this.search, payload.cfg, payload.sort)
            : this.$intervenersService.getInterveners(payload.sort, payload.cfg);
        case 'accounts':
          payload.cfg.params = payload.cfg.params || {};
          payload.cfg.params['$expand'] = 'interveners,distributor,subdistributor';
          if (this.$route.query['modifications-monitor']) {
            payload.cfg.params['modifications-monitor'] = this.$route.query['modifications-monitor'];
          }
          if (this.allowExternalCodesFromSystemMappings()) {
            payload.cfg.params['extCodesFromSM'] = true;
          }
          return hasSearch
            ? this.$accountsService.getSearch(this.search, payload.cfg, payload.sort)
            : this.$accountsService.getAccounts(payload.sort, payload.cfg);
        case 'operations':
          payload.cfg.params = payload.cfg.params || {};
          payload.cfg.params['$expand'] = 'interveners';
          return hasSearch
            ? this.$operationsService.getSearch(this.search, payload.cfg, payload.sort)
            : this.$operationsService.getOperations(payload.sort, payload.cfg);
        default:
          break;
      }
    },

    /**
     * CARGAMOS LOS DATOS DE UNA TABLA
     * Consultamos los datos iniciales de una tabla
     * @param {Object} payload Sección que se quiere paginar, ordenación y cfg
     * @return {Object} Resultados de la tabla
     */
    download(payload) {
      if (typeof payload.sort === 'object') {
        payload.sort = '';
      }
      switch (payload.section) {
        case 'issues':
          return this.$issuesService.download(payload.sort, payload.cfg, payload.headers);
        case 'users':
          return this.$usersService.download(payload.sort, payload.cfg, payload.headers);
        case 'groups':
          return this.$groupsService.download(payload.sort, payload.cfg, payload.headers);
        case 'permission_set':
          return this.$permissionService.download(payload.sort, payload.cfg, payload.headers);
        case 'interveners':
          return this.$intervenersService.download(payload.sort, payload.cfg, payload.headers);
        case 'accounts':
          payload.cfg.params['$expand'] = 'interveners,distributor,subdistributor';
          return this.$accountsService.download(payload.sort, payload.cfg, payload.headers);
        case 'operations':
          payload.cfg.params['$expand'] = 'interveners';
          return this.$operationsService.download(payload.sort, payload.cfg, payload.headers);
        default:
          break;
      }
    },

    /**
     * PAGINACIÓN DE UNA TABLA
     * Cuando llamamos al scroll infinito de una tabla necesitamos hacer una paginación de resultados.
     * Este método se encarga de ver qué sección se quiere paginar y le pasamos el link a donde queremos hacer
     * la petición de paginación. Obtenemos una promesa con los resultados paginados.
     * @param {Object} payload Sección que se quiere paginar y link al que hacer la petición
     * @return {Object} Resultados de la paginación
     */
    pagination(payload) {
      this.isLoading = true;
      switch (payload.section) {
        case 'issues':
          return this.$issuesService.getPagination(payload.href);
        case 'users':
          return this.$usersService.getUsersPagination(payload.href);
        case 'groups':
          return this.$groupsService.getPagination(payload.href);
        case 'permission_set':
          return this.$permissionService.getPagination(payload.href);
        case 'interveners':
          return this.$intervenersService.getPagination(payload.href);
        case 'accounts':
          return this.$accountsService.getPagination(payload.href);
        case 'operations':
          return this.$operationsService.getPagination(payload.href);
        default:
          break;
      }
    },

    // cargamos las vistas de la sección
    async loadSectionViews() {
      try {
        const { user } = localStorageUser();
        const response = await this.$usersService.getSectionViews(user.uuid, this.section);
        this.views = response.data.sections_views;
      } catch (error) {
        this.$toast.error(`Error loading views`, `${error.message}`);
      }
    },

    calculateColumnsWith(columns) {
      const widthColumnFromView = {};
      columns.forEach(col => (widthColumnFromView[col.field] = col.width || 150));
      localStorage.setItem(`table_width_${this.$route.name}`, JSON.stringify(widthColumnFromView));
      this.$root.$emit('refreshWidthColumns', widthColumnFromView);
    },

    saveFiltersAndOrderBy(view) {
      switch (this.section) {
        case 'accounts':
          this.saveFilterInLocalstore(this.tbFilters, 'filt_acco');
          this.saveFilterInLocalstore(this.orderby, 'ob_acco');
          break;
        case 'groups':
          this.saveFilterInLocalstore(this.tbFilters, 'filt_grp');
          this.saveFilterInLocalstore(this.orderby, 'ob_grp');
          break;
        case 'interveners':
          this.saveFilterInLocalstore(this.tbFilters, 'filt_int');
          this.saveFilterInLocalstore(this.orderby, 'ob_int');
          break;
        case 'issues':
          this.saveFilterInLocalstore(this.tbFilters, 'filt_issu');
          this.saveFilterInLocalstore(this.orderby, 'ob_issu');
          break;
        case 'operations':
          this.saveFilterInLocalstore(this.tbFilters, 'filt_oper');
          this.saveFilterInLocalstore(this.orderby, 'ob_oper');
          this.saveFilterInLocalstore(view.columns, 'col_oper');
          break;
        case 'permission_sets':
          this.saveFilterInLocalstore(this.tbFilters, 'filt_perm');
          this.saveFilterInLocalstore(this.orderby, 'ob_perm');
          break;
        case 'users':
          this.saveFilterInLocalstore(this.tbFilters, 'filt_usr');
          this.saveFilterInLocalstore(this.orderby, 'ob_usr');
          break;
        default:
          break;
      }
    },

    refreshRoute(payload, viewColumns) {
      this.$router.replace(payload).then(() => {
        this.sort(this.orderby);
        this.columns = viewColumns;
        this.componentKey++;
      });
    },

    loadModificationsMonitorView(view, loadFiltersAndOrderby = true) {
      if (loadFiltersAndOrderby) {
        if (view.filter) {
          this.tbFilters = JSON.parse(decodeURIComponent(escape(atob(view.filter))));
          this.applyFilters(this.tbFilters);
        }
        if (view.orderby) {
          this.orderby = JSON.parse(decodeURIComponent(escape(atob(view.order_by))));
        }
        if (view.filter || view.orderby) {
          this.saveFiltersAndOrderBy(view);
        }
      }
      // the modifications-monitor flag is sent to the backend and forces the endpoint to
      // return data for the modifications monitor columns instead of the ordinary ones
      const payload = {
        path: this.$route.path,
        query: {
          'modifications-monitor': true,
          'sorts-by': this.orderby,
          req: Math.floor(Math.random() * 1000) // to avoid navigate on the same route
        }
      };
      this.refreshRoute(payload, view.columns);
    },

    loadGeneralView(view) {
      this.tbFilters = view.filter ? JSON.parse(decodeURIComponent(escape(atob(view.filter)))) : [];
      this.orderby = view.order_by ? JSON.parse(decodeURIComponent(escape(atob(view.order_by)))) : null;
      this.columns = view.columns;
      this.applyFilters(this.tbFilters);
      this.saveFiltersAndOrderBy(view);
      const payload = {
        path: this.$route.path,
        query: {
          'sorts-by': this.orderby,
          req: Math.floor(Math.random() * 1000) // to avoid navigate on the same route
        }
      };
      this.refreshRoute(payload, view.columns);
    },

    /**
     * CARGAMOS LA INFORMACIÓN DE LA VISTA
     * @param {Object} view Vista
     */
    loadView(view) {
      localStorage.setItem(`table_view_selected_${this.$route.name}`, JSON.stringify(view));
      switch (view.type) {
        case 'MODIFICATIONS_MONITOR':
          this.loadModificationsMonitorView(view);
          break;

        default:
          this.loadGeneralView(view);
          break;
      }
    },

    /**
     * GUARDAR VISTA ACTUAL
     * Guardamos los filtros y ordenación actuales en una nueva vista
     * @param {String} payload Título de la vista
     */
    async saveView({ title, widths }) {
      try {
        const { user } = localStorageUser();
        const view = {
          title,
          columns: this.columns.map(x => {
            return { ...x, width: widths[x.field] };
          }),
          filters: btoa(unescape(encodeURIComponent(JSON.stringify(this.tbFilters)))),
          orderby: btoa(unescape(encodeURIComponent(JSON.stringify(this.orderby))))
        };
        await this.$usersService.createSectionView(user.uuid, this.section, view);
        this.loadSectionViews();

        const payload = {
          path: this.$route.path,
          query: {
            'sorts-by': this.orderby,
            req: Math.floor(Math.random() * 1000) // to avoid navigate on the same route
          }
        };
        this.$router.replace(payload).then(() => {
          this.columns = view.columns;
          view.order_by = view.orderby;
          view.filter = view.filters;
          this.loadView(view);
        });
        this.$toast.success(`Vista guardada`, `Se ha guardado la vista con éxito.`);
      } catch (error) {
        this.$toast.error(`Error creating view`, `${error.message}`);
      }
    },

    /**
     * EDITAR VISTA
     * Editamos el título de una vista
     * @param {Object} data Nuevo título de la vista y id de la vista
     */
    editView(data) {
      const view = {
        filters: btoa(unescape(encodeURIComponent(JSON.stringify(this.tbFilters)))),
        orderby: btoa(unescape(encodeURIComponent(JSON.stringify(this.orderby)))),
        title: data.title,
        columns: this.columns
      };

      this.$usersService
        .updateSectionView(data.view.uuid_user, data.view.uuid, view)
        .then(() => {
          this.loadSectionViews();
          this.$toast.success(`Vista actualizada`, `Se ha actualizado la vista con éxito.`);
        })
        .catch(err => this.$toast.error(`Error updating view`, `${err.message}`));
    },

    /**
     * ELIMINAR VISTA
     * Borramos una vista
     * @override
     */
    deleteView(view) {
      const { user } = localStorageUser();
      this.$usersService
        .removeView(user.uuid, view.uuid)
        .then(() => {
          this.loadSectionViews();
          this.deselectView();
          this.$toast.success(`Vista eliminada`, `Se ha eliminado la vista con éxito.`);
        })
        .catch(err => this.$toast.error(`Error removing view`, `${err.message}`));
    },

    deselectView() {
      this.removeViewDataFromLocalStorage();
      const payload = {
        path: this.$route.path,
        query: {
          req: Math.floor(Math.random() * 1000) // to avoid navigate on the same route
        }
      };
      this.$router.replace(payload).then(() => {
        this.columns = null;
        this.tbFilters = [];
        this.filters = null;
        this.orderby = null;
        this.loadItems();
      });
    },

    removeViewDataFromLocalStorage() {
      this.removeFromLocalstore(`table_view_selected_${this.$route.name}`);
      switch (this.section) {
        case 'accounts':
          this.removeFromLocalstore('col_acco');
          this.removeFromLocalstore('filt_acco');
          this.removeFromLocalstore('ob_acco');
          this.removeFromLocalstore('search_acco');
          break;
        case 'groups':
          this.removeFromLocalstore('col_grp');
          this.removeFromLocalstore('filt_grp');
          this.removeFromLocalstore('ob_grp');
          this.removeFromLocalstore('search_grp');
          break;
        case 'interveners':
          this.removeFromLocalstore('col_int');
          this.removeFromLocalstore('filt_int');
          this.removeFromLocalstore('ob_int');
          this.removeFromLocalstore('search_int');
          break;
        case 'issues':
          this.removeFromLocalstore('col_issu');
          this.removeFromLocalstore('filt_issu');
          this.removeFromLocalstore('ob_issu');
          this.removeFromLocalstore('search_issu');
          break;
        case 'operations':
          this.removeFromLocalstore('col_oper');
          this.removeFromLocalstore('filt_oper');
          this.removeFromLocalstore('ob_oper');
          this.removeFromLocalstore('search_oper');
          break;
        case 'permission_sets':
          this.removeFromLocalstore('col_perm');
          this.removeFromLocalstore('filt_perm');
          this.removeFromLocalstore('ob_perm');
          this.removeFromLocalstore('search_perm');
          break;
        case 'users':
          this.removeFromLocalstore('col_usr');
          this.removeFromLocalstore('filt_usr');
          this.removeFromLocalstore('ob_usr');
          this.removeFromLocalstore('search_usr');
          break;
        default:
          break;
      }
    },

    /**
     * CARGAMOS LOS DATOS EN LA TABLA
     * Cargamos los resultados obtenidos en la paginación a un array mapeado
     * @param {Array} results Resultados obtenidos en la paginación
     * @param {Array} _self_name_params Parámetros que se utilizan para formar el campo de la tabla que cogerá la pestaña al abrirla
     * @return {Array} Listado de resultados mapeado
     */
    loadDataInTable(results, _self_name_params) {
      const arrValues = [];
      const itemsPagged = this.mapSelfName(results, _self_name_params);
      itemsPagged.forEach(el => {
        arrValues.push(el);
      });
      setTimeout(() => {
        this.isLoading = false;
      }, 1000);

      return itemsPagged;
    },

    /**
     * Se eliminan los items eliminados del listado
     * @param {Array} uuidsDeletedItems Uuids de los items eliminados
     */
    filterDeletedItems(uuidsDeletedItems) {
      this.items = this.items.filter(item => !uuidsDeletedItems.includes(item.uuid));
    },

    /**
     * GUARDAMOS LOS FILTROS APLICADOS
     * Guardamos en localStore los filtros aplicados por el usuario para que cuando navegue entre las diferentes secciones
     * y vuelva a un listado ya filtrado anteriormente, tenga los filtros aplicados automáticamente
     * @param {Array} filters Filtros aplicados
     * @param {String} key Key con el que se guardarán los filtros
     */
    saveFilterInLocalstore(filters, key) {
      localStorage.setItem(key, btoa(unescape(encodeURIComponent(JSON.stringify(filters)))));
    },

    /**
     * Elimina de localStorage
     * @param {String} key Key a eliminar
     */
    removeFromLocalstore(key) {
      localStorage.removeItem(key);
    },

    /**
     * CARGAMOS LOS FILTROS APLICADOS
     * Obtenemos desde el localStore los filtros de una tabla que haya podido filtrar el usuario
     * @param {String} key Key con el que se guardarán los filtros
     * @return {Array} Array de filtros
     */
    loadFilterInLocalstore(key) {
      return localStorage.getItem(key) ? JSON.parse(decodeURIComponent(escape(atob(localStorage.getItem(key))))) : [];
    },

    /**
     * APLICAMOS FILTROS
     * Aplicamos los filtros que tiene seleccionado el usuario
     * @param {Array} filters Filtros aplicados
     * @param {Array} customFilters Filtros personalizados opcionales formados por field (nombre del campo al que aplicarlo) y _function (función a la que llamar)
     */
    applyFilters(filters, customFilters = []) {
      const filtersSet = {};
      filters.forEach(filterData => {
        if (!filtersSet[filterData.field]) {
          filtersSet[filterData.field] = [];
        }
        if (customFilters.length > 1) {
          customFilters.forEach(
            customFilter => customFilter.field === filterData.field && customFilter._function(filterData)
          );
        }
        const newFilter = {};
        if (filterData.orFilter) {
          newFilter.or = '';
        }
        if (
          filterData.conditionValue &&
          typeof filterData.conditionValue !== 'boolean' &&
          !Date.parse(filterData.conditionValue)
        ) {
          filterData.conditionValue = filterData.conditionValue.replace(/%/g, '\\%');
        }
        if (filterData.condition === 'in_starts') {
          newFilter.in = `${filterData.conditionValue}%`;
        } else if (filterData.condition === 'in' || filterData.condition === 'nin') {
          newFilter[filterData.condition] = `%${filterData.conditionValue}%`;
        } else if (filterData.condition === 'null') {
          newFilter[filterData.condition] = '';
        } else if (filterData.condition === '!null') {
          newFilter[filterData.condition] = '';
        } else {
          newFilter[filterData.condition] = filterData.conditionValue;
        }
        filtersSet[filterData.field].push(newFilter);
      });
      this.filters = filtersSet;
    },

    /**
     * @override
     */
    async downloadExport(columns, format) {
      this.orderby = typeof this.orderby === 'object' ? '' : this.orderby;
      const payload = {
        section: this.section,
        headers: columns.map(x => x.name),
        cfg: {
          params: {
            // $filter: JSON.stringify(this.filters),
            $format: format,
            $offset: this.metadata.paging.offset,
            $limit: 999999999
          }
        },
        sort: this.orderby
      };
      if (this.$route.query['modifications-monitor']) {
        payload.cfg.params['modifications-monitor'] = true;
      }
      if (this.filters && Object.keys(this.filters).length) {
        payload.cfg.params['$filter'] = JSON.stringify(this.filters);
      }

      const exportsFormatter = new ExportsFormatter(this);
      try {
        const res = await exportsFormatter.getData(payload);
        const entities = exportsFormatter.parseDataResponse(res, this.$route.name);
        const headers = this.columns.filter(x => x.name !== 'interveners').map(x => x.name);

        exportsFormatter.formatEntitiesFields(entities, headers);
        exportsFormatter.applyTranslations(headers, entities);

        const fileData = await exportsFormatter.generateFile(format, headers, entities);
        exportsFormatter.downloadFile(fileData, this.$route.name, format);

        await this.$root.$emit('addDownloadToList', { fileData, section: this.$route.name, format });

        this.$toast.success(`Exportación completada`, `Documento ${format} descargado con éxito.`);
        this.$toast.success(`Exportación completada`, `El documento se ha adjuntado a la lista de exportaciones.`);
      } catch (err) {
        console.error(err);
        this.$toast.error(`Error ${err.name}`, `${err.message}`);
      }
    },

    /**
     * MAPEAMOS _SELF_NAME
     * @param {Array} data Datos a mapear
     * @param {Array} fields Campos que queremos añadir a _self_name
     * @return {Array} Array de datos mapeados
     */
    mapSelfName(data, fields) {
      return data.map(x => {
        x._self_name = fields.reduce((accumulator, currentValue) => `${accumulator} ${x[currentValue]}`, '').trim();
        return x;
      });
    },

    /**
     * OBTENEMOS LAS COLUMNAS
     * A partir de los resultados, cogemos el primer elemento y recorremos y mapeamos todas las columnas.
     * En el caso de que no se hayan obtenido elementos se inicializan los items y columnas.
     */
    getColumns() {
      if (!this.columns || !this.columns.length) {
        if (this.items && this.items.length >= 1) {
          const isModificationsMonitorView = this.$route.query.hasOwnProperty('modifications-monitor');
          const defaultColumns = isModificationsMonitorView
            ? this.defaultModificationsMonitorColumns
            : this.defaultColumns;
          const fields = Object.keys(this.items[0]);
          this.columns = fields.map(x => {
            return {
              name: x,
              field: x,
              active: defaultColumns.includes(x)
            };
          });

          const columnsOrdered = [];

          for (let index = 0; index < defaultColumns.length; index++) {
            const c = this.columns.find(x => x.name === defaultColumns[index]);
            if (c) {
              columnsOrdered.push(c);
            }
          }
          for (let index = 0; index < this.columns.length; index++) {
            if (!this.columns[index].active) {
              columnsOrdered.push(this.columns[index]);
            }
          }
          this.columns = columnsOrdered;
        } else {
          this.items = [];
          this.columns = [];
        }
      }
    },

    /**
     * Comprueba
     * @return {Boolean} Devuelve true si la tabla tiene scroll, Falso si no lo tiene
     * (puede no tener scroll porque haya menos elementos que el alto de la tabla o que no haya tabla por algún motivo)
     */
    tableHasScroll() {
      const jstable = document.getElementById('jstable');
      if (jstable) {
        const tableScrollElement = jstable.getElementsByClassName('v-table__scroll');
        if (tableScrollElement) {
          const hasVerticalScrollbar = tableScrollElement[0].scrollHeight >= tableScrollElement[0].clientHeight;
          return hasVerticalScrollbar;
        }
        return false;
      }
      return false;
    },

    getDefaultOrderBy() {
      switch (this.$route.name) {
        case 'accounts':
        case 'interveners':
        case 'operations':
        case 'issues':
          return  'created_on DESC';
        default:
          return '';
      }
    },
  }
};
